import React from 'react'
import { DeferredPost, PostTemplate } from '@3m5/sm_publish-frontend-api'
import { getTheme } from '../../../../store/common/common.selectors'
import { useSelector } from 'react-redux'
import { ScreenEnum, ViewEnum } from '@professocial/professocialTypes/types/commonTypes'
import ProfessocialPost from '../../../../screens/ProfessocialPost'
import { FilterType } from '../../../types/types'

interface IProps {
  post?: PostTemplate
  deferredPost?: DeferredPost
  filterType?: FilterType
  user?: any
}

const TemplatePost: React.FC<IProps> = (props) => {
  const theme = useSelector(getTheme)

  return (
    <>
      {props.user && (
        <ProfessocialPost
          postConfiguration={{
            theme: theme,
            userRole: props.user.role,
            size: ScreenEnum.xs,
            view: ViewEnum.templateUser,
            filterType: props.filterType,
            post: props.post,
            deferredPost: props.deferredPost,
          }}
        />
      )}
    </>
  )
}

export default TemplatePost
